import styled from 'styled-components';

const PhoneInputStyles = styled.div `
  .antd-country-phone-input {
    .ant-select {
      min-width: 90px;
      .ant-select-selection-search {
        padding-left: 8px;
      }
    }
    .ant-input-group-addon {
      background-color: inherit;
      .ant-select-focused {
        .ant-select-selector {
          color: inherit;
        }
      }
      .ant-select-selection-item {
        color: inherit;
      }
    }
  }
`;

export { PhoneInputStyles };
